function Coins() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20"
      height="18.857"
      data-name="Coin 20"
      viewBox="0 0 20 18.857">
      {' '}
      <defs>
        {' '}
        <clipPath id="clip-path">
          <path fill="none" d="M0 0H20V18.857H0z" data-name="Rectangle 2689"></path>{' '}
        </clipPath>{' '}
        <clipPath id="clip-path-2">
          {' '}
          <path
            fill="none"
            d="M28.723 46.364c-2.336 4.449-7.925 7.2-12.482 6.151a6.439 6.439 0 01-4.116-2.772l.725 1.147.725 1.147a6.439 6.439 0 004.116 2.772c4.558 1.052 10.146-1.7 12.482-6.152a7.1 7.1 0 00.1-7.191l-1.451-2.294a7.1 7.1 0 01-.1 7.191"
            data-name="Path 12494"
            transform="translate(-12.125 -39.173)"></path>{' '}
        </clipPath>{' '}
        <linearGradient
          id="linear-gradient"
          x1="-0.048"
          x2="-0.044"
          y1="0.95"
          y2="0.95"
          gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor="#ffa705"></stop>
          <stop offset="0.446" stopColor="#ff9605"></stop>
          <stop offset="1" stopColor="#ff8605"></stop>{' '}
        </linearGradient>{' '}
        <clipPath id="clip-path-3">
          {' '}
          <path
            fill="none"
            d="M11.484 0A12.358 12.358 0 001.023 6.376 8.378 8.378 0 000 10.241v.028a6.113 6.113 0 005.043 6.068c4.558 1.052 10.146-1.7 12.482-6.151s.537-8.911-4.021-9.963A8.965 8.965 0 0011.491 0z"
            data-name="Path 12495"
            transform="translate(0 .001)"></path>{' '}
        </clipPath>{' '}
        <clipPath id="clip-path-5">
          <path fill="none" d="M0 0H17.291V16.485H0z" data-name="Rectangle 2680"></path>{' '}
        </clipPath>{' '}
        <clipPath id="clip-path-6">
          <path fill="none" d="M0 0H17.206V13.667H0z" data-name="Rectangle 2681"></path>{' '}
        </clipPath>{' '}
        <clipPath id="clip-path-8">
          {' '}
          <path
            fill="none"
            d="M29.455 30.487c-1.784 3.4-.409 6.8 3.069 7.606s7.748-1.3 9.531-4.7.409-6.8-3.071-7.606a6.849 6.849 0 00-1.541-.171 9.435 9.435 0 00-7.989 4.868"
            data-name="Path 12500"
            transform="translate(-28.674 -25.619)"></path>{' '}
        </clipPath>{' '}
        <linearGradient
          id="linear-gradient-2"
          x1="-0.074"
          x2="-0.069"
          y1="1.273"
          y2="1.273"
          xlinkHref="#linear-gradient"></linearGradient>{' '}
        <clipPath id="clip-path-10">
          {' '}
          <path
            fill="#ffd105"
            d="M63.353 71.984l-1.924 1.489-.39-1.087a.484.484 0 00-.331-.342c-.208-.048-.465.079-.685.383-.551.759-1.542 2.32-2.093 3.08-.369.51-.253 1.018.3 1.145L64 77.984a1.144 1.144 0 001.308-.774c.282-.822.965-2.454 1.246-3.276.111-.329.029-.535-.18-.583a.9.9 0 00-.58.132l-1.322.692-.115-1.96a.447.447 0 00-.317-.466.457.457 0 00-.1-.011 1.007 1.007 0 00-.584.246"
            data-name="Path 12502"
            transform="translate(-57.718 -71.738)"
            style={{ mixBlendMode: 'overlay', isolation: 'isolate' }}></path>{' '}
        </clipPath>{' '}
        <linearGradient
          id="linear-gradient-3"
          x1="-0.293"
          x2="-0.286"
          y1="1.476"
          y2="1.476"
          gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor="#ffea05"></stop>
          <stop offset="0.603" stopColor="#ffca05"></stop>
          <stop offset="1" stopColor="#ffcd05"></stop>{' '}
        </linearGradient>{' '}
        <clipPath id="clip-path-12">
          <path fill="none" d="M0 0H8.886V5.625H0z" data-name="Rectangle 2687"></path>{' '}
        </clipPath>{' '}
      </defs>{' '}
      <g clipPath="url(#clip-path)" data-name="Group 9095">
        {' '}
        <g data-name="Group 9070" transform="translate(.927 2.996)">
          {' '}
          <g clipPath="url(#clip-path-2)" data-name="Group 9069">
            {' '}
            <path
              fill="url(#linear-gradient)"
              d="M0 0H19.429V16.689H0z"
              data-name="Rectangle 2678"></path>{' '}
          </g>{' '}
        </g>{' '}
        <g data-name="Group 9072">
          {' '}
          <g clipPath="url(#clip-path-3)" data-name="Group 9071">
            {' '}
            <path
              fill="#ffd105"
              d="M0 0H26.236V25.619H0z"
              data-name="Rectangle 2679"
              transform="rotate(-34.81 4.969 15.836)"></path>{' '}
          </g>{' '}
        </g>{' '}
        <g data-name="Group 9083">
          {' '}
          <g clipPath="url(#clip-path)" data-name="Group 9082">
            {' '}
            <g
              data-name="Group 9075"
              opacity="0.4"
              transform="translate(.067 .077)"
              style={{ mixBlendMode: 'overlay', isolation: 'isolate' }}>
              {' '}
              <g data-name="Group 9074">
                {' '}
                <g fill="#fff" clipPath="url(#clip-path-5)" data-name="Group 9073">
                  {' '}
                  <path
                    d="M81.219 1.008a12.119 12.119 0 00-4.386 1.453l8.456 12.407a11.772 11.772 0 003.026-3.449z"
                    data-name="Path 12496"
                    transform="translate(-71.024 -1.008)"></path>{' '}
                  <path
                    d="M3.786 48.721a11.248 11.248 0 00-1.952 2.651 8.809 8.809 0 00-.956 2.906l4.772 7c.068.018.135.037.2.053a10.44 10.44 0 006.123-.593z"
                    data-name="Path 12497"
                    transform="translate(-.878 -45.072)"></path>{' '}
                </g>{' '}
              </g>{' '}
            </g>{' '}
            <g
              data-name="Group 9078"
              opacity="0.7"
              transform="translate(1.425 2.996)"
              style={{ mixBlendMode: 'overlay', isolation: 'isolate' }}>
              {' '}
              <g data-name="Group 9077">
                {' '}
                <g clipPath="url(#clip-path-6)" data-name="Group 9076">
                  {' '}
                  <path
                    fill="#fff"
                    d="M34.735 46.364c-2.336 4.449-7.924 7.2-12.482 6.151a6.636 6.636 0 01-3.618-2.1 6.6 6.6 0 003.7 2.2c4.558 1.052 10.146-1.7 12.482-6.151a7.223 7.223 0 00.3-6.831l-.291-.46a7.1 7.1 0 01-.1 7.191"
                    data-name="Path 12498"
                    transform="translate(-18.635 -39.173)"></path>{' '}
                </g>{' '}
              </g>{' '}
            </g>{' '}
            <g
              data-name="Group 9081"
              transform="translate(2.794 5.19)"
              style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}>
              {' '}
              <g data-name="Group 9080">
                {' '}
                <g clipPath="url(#clip-path-6)" data-name="Group 9079">
                  {' '}
                  <path
                    fill="#e86b05"
                    d="M52.629 75.055c-2.336 4.449-7.924 7.2-12.482 6.151a6.636 6.636 0 01-3.618-2.1 6.6 6.6 0 003.7 2.2c4.558 1.052 10.146-1.7 12.482-6.151a7.223 7.223 0 00.3-6.831l-.291-.46a7.1 7.1 0 01-.1 7.191"
                    data-name="Path 12499"
                    transform="translate(-36.529 -67.864)"></path>{' '}
                </g>{' '}
              </g>{' '}
            </g>{' '}
          </g>{' '}
        </g>{' '}
        <g data-name="Group 9085" transform="translate(2.193 1.959)">
          {' '}
          <g clipPath="url(#clip-path-8)" data-name="Group 9084">
            {' '}
            <path
              fill="url(#linear-gradient-2)"
              d="M0 0H16.168V13.277H0z"
              data-name="Rectangle 2684"
              transform="translate(-1.003)"></path>{' '}
          </g>{' '}
        </g>{' '}
        <g data-name="Group 9087">
          {' '}
          <g clipPath="url(#clip-path)" data-name="Group 9086">
            {' '}
            <path
              fill="#e86b05"
              d="M68.241 76.4a.264.264 0 00-.04-.049l-.326-.393-1.735.806-.1-1.623a.562.562 0 00-.123-.343v-.006l-.352-.451-.6.62-1.857 1.437-.39-1.087a.589.589 0 00-.163-.251l-.359-.479-.786 1.079-2.3 3.148.41.534a.688.688 0 00.4.231l5.77 1.332a1.144 1.144 0 001.308-.774c.281-.822.964-2.454 1.246-3.276a.546.546 0 000-.459"
              data-name="Path 12501"
              transform="translate(-54.589 -68.651)"></path>{' '}
          </g>{' '}
        </g>{' '}
        <g data-name="Group 9089" transform="translate(4.414 5.487)">
          {' '}
          <g clipPath="url(#clip-path-10)" data-name="Group 9088">
            {' '}
            <path
              fill="url(#linear-gradient-3)"
              d="M0 0H11.113V10.431H0z"
              data-name="Rectangle 2686"
              transform="rotate(-34.828 1.742 6.051)"></path>{' '}
          </g>{' '}
        </g>{' '}
        <g data-name="Group 9094">
          {' '}
          <g clipPath="url(#clip-path)" data-name="Group 9093">
            {' '}
            <path
              fill="#e86b05"
              d="M29.865 31.008c1.784-3.4 6.051-5.5 9.53-4.7A5.09 5.09 0 0142.1 27.85a4.931 4.931 0 00-3.106-2.06c-3.479-.8-7.746 1.3-9.53 4.7a5.24 5.24 0 00.365 6.068 5.4 5.4 0 01.035-5.547"
              data-name="Path 12503"
              transform="translate(-26.49 -23.66)"></path>{' '}
            <g
              data-name="Group 9092"
              opacity="0.4"
              transform="translate(4.414 5.487)"
              style={{ mixBlendMode: 'overlay', isolation: 'isolate' }}>
              {' '}
              <g data-name="Group 9091">
                {' '}
                <g fill="#fff" clipPath="url(#clip-path-12)" data-name="Group 9090">
                  {' '}
                  <path
                    d="M124.07 73.352a.9.9 0 00-.58.132l-1.322.692-.115-1.96a.447.447 0 00-.317-.466.875.875 0 00-.687.234l-.858.664 2.914 4.276c.319-.872.892-2.255 1.144-2.99.112-.329.029-.534-.18-.583"
                    data-name="Path 12504"
                    transform="translate(-115.413 -71.738)"></path>{' '}
                  <path
                    d="M61.312 104.1l-2.325-3.411c-.389.585-.779 1.172-1.056 1.554-.369.51-.253 1.018.3 1.145z"
                    data-name="Path 12505"
                    transform="translate(-57.718 -98.473)"></path>{' '}
                </g>{' '}
              </g>{' '}
            </g>{' '}
          </g>{' '}
        </g>{' '}
      </g>{' '}
    </svg>
  );
}

export default Coins;
